import React, { useEffect, useState } from "react";
import './HOC.css'
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import endPoints from "../../Repository/apiConfig";
import { getApi } from "../../Repository/Api";


const HOC = (WrappedComponent) => {
    const Component = () => {
        const [show, setShow] = useState(true);
        const toggleSidebar = () => setShow(prevShow => !prevShow);
        const [profile, setProfile] = useState({});
        const [loading, setLoading] = useState(false);



        const fetchData = async () => {
            await getApi(endPoints.getprofile, {
                setResponse: (response) => {
                    setProfile(response);
                    localStorage.setItem("adminData", JSON.stringify(response)); // Cache the response
                },
                setLoading,
                errorMsg: "Failed to fetch profile!",
            });
        };


        useEffect(() => {
            // Check for cached data in localStorage
            const cachedAdminData = localStorage.getItem("adminData");

            if (cachedAdminData) {
                // Use cached data
                setProfile(JSON.parse(cachedAdminData));
            } else {
                // Fetch and cache data if no cached data exists
                fetchData();
            }
        }, []);



        return (
            <div className={`container1 ${show ? '' : 'sidebar-hidden'}`}>
                {/* {show && ( */}
                    <div className="sidebar55">
                        <Sidebar toggleSidebar={toggleSidebar} />
                    </div>
                {/* )} */}
                <div className="content">
                    <Navbar show={show} toggleSidebar={toggleSidebar} admindata={profile} />
                    <div className="child-component">
                        <WrappedComponent />
                    </div>
                </div>
            </div>
        );
    };

    return Component;
};

export default HOC;